import React from 'react';
import { useEmployeeDashboard } from './hooks/useEmployeeDashboard';
import DashboardWelcomeBanner from './components/DashboardWelcomeBanner';
import TodayPunchCard from './components/TodayPunchCard';
import MonthlyAttendanceKPICards from './components/MonthlyAttendanceKPICards';
import UpcomingBirthdaysWidget from './components/UpcomingBirthdaysWidget';
import UpcomingAnniversariesWidget from './components/UpcomingAnniversariesWidget';
import QuickActionsGrid from './components/QuickActionsGrid';
import ManagerPendingWidget from './components/ManagerPendingWidget';

export default function EmployeeDashboardScreen() {
  const { data, isLoading, isRefreshing, currentTime, handleRefresh } = useEmployeeDashboard();

  if (isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <div className="h-10 w-10 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <span className="text-xs font-semibold text-on-surface-variant">
            Loading Employee Self-Service Dashboard...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-16">
      {/* 1. Welcome & Shift Header */}
      <DashboardWelcomeBanner
        user={data?.currentUser}
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
      />

      {/* 2. Manager Pending Approvals Banner (If applicable) */}
      {data?.pendingApprovals && (
        <ManagerPendingWidget pendingApprovals={data.pendingApprovals} />
      )}

      {/* 3. Monthly Attendance KPI Cards */}
      <MonthlyAttendanceKPICards metrics={data?.metrics} />

      {/* 4. Core Activity Grid: Today's Punch, Birthdays & Anniversaries */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Real-time Punch Status Card */}
        <TodayPunchCard
          todayPunch={data?.todayPunch}
          currentTime={currentTime}
        />

        {/* Upcoming Birthdays Widget */}
        <UpcomingBirthdaysWidget birthdays={data?.birthdays || []} />

        {/* Upcoming Anniversaries Widget */}
        <UpcomingAnniversariesWidget anniversaries={data?.anniversaries} />
      </div>

      {/* 5. Quick ESS Action Portals */}
      <QuickActionsGrid actions={data?.quickActions || []} />
    </div>
  );
}

